import { states } from "@/common/data/stateAndLocal";

export const registerInvitedInput = (email: string) => [
  {
    inputType: "text",
    prompt: "First Name",
    name: "first_name",
    placeholder: "Enter your first name",

    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Should be atleast 6 characters",
      },
    },
  },

  {
    inputType: "text",
    prompt: "Last Name",
    name: "last_name",
    placeholder: "Enter your last name",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Should be atleast 6 characters",
      },
    },
  },
  {
    inputType: "email",
    prompt: "Email",
    name: "email",
    placeholder: "Enter your email",
    fullWidth: false,
    initialValue: email,
    readOnly: !!email,
    rules: {
      validEmail: {
        expectedValue: true,
        errorMessage: "Invalid email",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Company Phone number",
    name: "phone_number",
    placeholder: "Enter the company's phone number",
    fullWidth: false,
    rules: {
      validNigerianPhoneNumber: {
        expectedValue: true,
        errorMessage: "Invalid Nigerian phone number",
      },
    },
  },
  {
    inputType: "selectParent",
    prompt: "State",
    name: "state_of_residence",
    placeholder: "Select state",
    fullWidth: false,
    options: states,
  },
  {
    inputType: "selectChild",
    prompt: "LGA",
    name: "lga_of_residence",
    placeholder: "Select LGA",
    fullWidth: false,
    options: states,
    parentName: "state_of_residence",
  },
  {
    inputType: "text",
    prompt: "Address",
    name: "address",
    placeholder: "Enter your address",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 6,
        errorMessage: "Should be atleast 6 characters",
      },
    },
  },
  {
    inputType: "password",
    prompt: "Password",
    name: "password",
    placeholder: "Enter password",
    fullWidth: false,
  },
  {
    inputType: "password",
    prompt: "Confirm Password",
    name: "password_confirmation",
    placeholder: "Confirm password",
    fullWidth: false,
    rules: {
      compareWithExisting: {
        expectedValue: "password",
        errorMessage: "Does not match the password",
      },
    },
  },
];
